import { Config } from '@/config/types';

const productionConfig: Config = {
  configType: 'production',
  apiRoot: 'https://7ajq1kzbn2.execute-api.ap-southeast-1.amazonaws.com',
  apiEmailRoot: 'https://api.quiz.mynooci.com',
};

export default productionConfig;
